(function(global, factory) {
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = global.document ? 
      factory(global, true) : 
      function(w) {
        if (!w.document) {
          throw new Error("choiceSkuPopView requires a window with a document");
        }
        return factory(w);
      };
  }
  else {
    factory(global);
  }

}(typeof window !== "undefined" ? window : this, function(window) {
  var $ = {};
  var style = "#_choiceSkuPopView-container {position: fixed;top: 0px;left: 0px;width: 100%;height: 100%;z-index: 503;background-color: rgba(0, 0, 0, 0.25);}";

  var _choiceSkuPopView = function() {
    this.alsolikeStatus = false;
    this.index = 0;
    this.dataJson = {};
    this.productAid = ''; //算法aid
    this.moduleType = 'other'; //加购模块
    // 存储加载过的sku弹窗
    this.skuContainer = {};
    
    var $style = document.createElement('style');
    $style.innerText = style;
    $style.type = 'text/css';

    this.$container = document.createElement('div');
    this.$container.id = '_choiceSkuPopView-container';
    this.$container.className = 'choiceSkuPopView-fadeStart';
    document.body.appendChild(this.$container);
    document.head.appendChild($style);

    //绑定事件
    this.bind();
  }

  _choiceSkuPopView.prototype.bind = function() {
    
  }

  _choiceSkuPopView.prototype.requestProductData = function(productId, productUrl, status) {
    var _this = this;
    
    _this.alsolikeStatus = status;
    _this.$container.className += ' choiceSkuPopView-fadeEnd';
    _this.$container.innerText = '';
    
    var homePath = LS.site.dir.length > 0 ? LS.site.dir : '/';
    if (location.pathname == homePath) {
      var divor = document.querySelector('.h-featured-collection-listbox .h-featured-list-columnbox .h-silderbox-title-center');
      if (divor) {
        _this.moduleType = divor.innerText;
      }
    }
     else if (location.pathname.includes("/products/")) {
      var innerText;
      var divor = document.querySelector('.h-cart-drawer .h-cart-drawer-wrapper #h-collection-bought-together .h-collection-bought-together-title');
      if (divor) {
        innerText = divor.innerText;
      }
      else {
        innerText = 'Bought Together'
      }
      _this.moduleType = 'bought-together-' + innerText;
    }
     else {
      _this.moduleType = 'other';
    }

    var contentDiv = _this.skuContainer[productId];
    if (contentDiv) {
      _this.$container.appendChild(contentDiv);
      // 调用弹窗方法
      showSkuPopView(productId, Date.now());
    } 
    else {
      _this.startLoading();

      // 判断地址里面是否包含问号
      if ( productUrl && productUrl.length > 0 && productUrl.indexOf("?",0) != -1 ) {
        var requestUrl = productUrl + '&sections=product-choosesku-popup';
      } else {
        var requestUrl = productUrl + '?sections=product-choosesku-popup';
      }
      // 开始时间
      const startTime = Date.now();
      // 调用接口获取弹窗dom
      jQuery.ajax({
        url: requestUrl,
        type: 'GET',
        dataType: 'html',
        success: function(getdata) {
          // _this.endLoading();
          var responseHTML = JSON.parse(getdata)['product-choosesku-popup'];
          // 动态插入商品弹窗
          _this.start(productId, responseHTML, startTime);
          // // 调用弹窗方法
          // showSkuPopView(productId, startTime);
        },
        error: function() {
          _this.endLoading();
        }
      })
    }
  }

  _choiceSkuPopView.prototype.start = function(productId, resHtml, startTime) {
    // 调用查询详情页信息接口
    try{
      // 调用获取商品size相关信息的方法，参数：商品ID，来源, callback
      var _that = this;
      try {
        getQueryProductPropertyInfo(productId, '3', function(getProductSizeTabletHtmlStr) {
          // 结束loading
          _that.endLoading(); 
          // 添加到详情页页面
          var resDiv = document.createElement('div');
          resDiv.innerHTML = resHtml;

          var contentDiv = resDiv.querySelector('#shopify-section-product-choosesku-popup');
          var describe = contentDiv.querySelector('.h-size-describe-commodity-data');

          if ( getProductSizeTabletHtmlStr ) {
            describe.innerHTML = getProductSizeTabletHtmlStr;
          }

          contentDiv.style.display = 'block';
          _that.$container.appendChild(contentDiv);

          if (!_that.skuContainer[productId]) {
            _that.skuContainer[productId] = contentDiv;
          }

          // 调用弹窗方法
          showSkuPopView(productId, startTime);

        });
      } catch (error) {
        console.error('error1', error);

        var resDiv = document.createElement('div');
        resDiv.innerHTML = resHtml;

        var contentDiv = resDiv.querySelector('#sy-product-popup-content-box');
        contentDiv.style.display = 'block';

        _that.$container.appendChild(contentDiv);
        if (!_that.skuContainer[productId]) {
          _that.skuContainer[productId] = contentDiv;
        }
        // 调用弹窗方法
        showSkuPopView(productId, startTime);

        window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'sy-choicesku-popup.js', ext3: '158'});
      }
      
    }catch(error) {
      var resDiv = document.createElement('div');
      resDiv.innerHTML = resHtml;

      var contentDiv = resDiv.querySelector('#sy-product-popup-content-box');


      contentDiv.style.display = 'block';
      this.$container.appendChild(contentDiv);

      if (!this.skuContainer[productId]) {
        this.skuContainer[productId] = contentDiv;
      }

      // 调用弹窗方法
      showSkuPopView(productId, startTime);

      window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: error+'', ext2: 'sy-choicesku-popup.js', ext3: '178'});
    }
  }

  _choiceSkuPopView.prototype.close = function() {
    this.$container.classList.remove('choiceSkuPopView-fadeEnd');
  }

  _choiceSkuPopView.prototype.removeAll = function() {
    this.$container.innerText = '';
    this.$container.classList.remove('choiceSkuPopView-fadeEnd');
  }

  _choiceSkuPopView.prototype.startLoading = function() {
    if (!this.$loadingDiv) {
      var loadingDiv = document.createElement('div');
      loadingDiv.className = 'sy-choiceSku-loading';
      loadingDiv.innerHTML = '<img class="sy-choiceSku-loading-img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/sy-loading.gif?v=1645585698">';
      this.$loadingDiv = loadingDiv;
    }

    this.$loadingDiv.style.display = 'block';
    this.$container.appendChild(this.$loadingDiv);
  }

  _choiceSkuPopView.prototype.endLoading = function() {
    this.$loadingDiv.style.display = 'none';
    this.$container.removeChild(this.$loadingDiv);
  }

  window.choiceSkuPopView = new _choiceSkuPopView();
  if (typeof define === "function" && define.amd) {
    define([], function() {
      return choiceSkuPopView;
    });
  }

  return choiceSkuPopView;
}));
